import type { WidgetMountOptions } from './types/config';
import type { WidgetInstance } from './widget';
import { CryptoPayWidgetRuntime } from './widget';

const widgetRegistry = new WeakMap<HTMLElement, WidgetInstance>();

export async function mount(options: WidgetMountOptions): Promise<WidgetInstance> {
  const container =
    typeof options.container === 'string'
      ? document.querySelector<HTMLElement>(options.container)
      : options.container;

  if (!container) {
    throw new Error(`Widget container not found: ${String(options.container)}`);
  }

  const existingInstance = widgetRegistry.get(container);

  if (existingInstance) {
    existingInstance.destroy();
    widgetRegistry.delete(container);
  }

  const instance = new CryptoPayWidgetRuntime({
    ...options,
    container
  });

  widgetRegistry.set(container, instance);
  await instance.init();

  return instance;
}